import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 28C31415-ECC5-4192-A04A-C3C1F810019B
 * name message-settings-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-settings-outline.svg
 * tags
 * - Settings 
 */
export const MessageSettingsOutlineIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16M11 24H13V22H11V24M7 24H9V22H7V24M15 24H17V22H15V24" /></>, 'MessageSettingsOutlineIcon');
export default MessageSettingsOutlineIcon